// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { append, insertItem, patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { StandService } from '../../services/stand.service';
import {
  AcceptedStandCountWS,
  ClearScrollPositionStandList,
  CreatedStandByWS,
  GetStandList,
  GetStandListError,
  GetStandListSuccess,
  GetStandsCount,
  GetStandStatusList,
  GetStandStatusListError,
  GetStandStatusListSuccess,
  SetLastOpenedStandId,
  StandsCountWS,
  UpdatedStandByWS,
  UpdateScrollPositionStandList
} from './stand-list.actions';
import { STAND_LIST_STATE_DEFAULT, StandListStateModel } from './stand-list.model';

@State({ name: 'StandList', defaults: STAND_LIST_STATE_DEFAULT })
@Injectable()
export class StandListState {

  constructor(private standService: StandService, private store: Store) {
  }

  @Selector()
  static standsCount(state: StandListStateModel): StandListStateModel['standsCount'] {
    return state.standsCount;
  }

  @Selector()
  static standStatusList(state: StandListStateModel): StandListStateModel['standStatusList'] {
    return state.standStatusList;
  }

  @Selector()
  static standList(state: StandListStateModel): StandListStateModel['standList'] {
    return state.standList;
  }

  @Selector()
  static loadStandListStatus(state: StandListStateModel): StandListStateModel['loadStandListStatus'] {
    return state.loadStandListStatus;
  }

  @Selector()
  static lastOpenedDocId(state: StandListStateModel): StandListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: StandListStateModel): StandListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }

  @Action(GetStandList)
  getStandList(ctx: StateContext<StandListStateModel>, { filter, lazy }: GetStandList): void {
    if (lazy) {
      const next = ctx.getState().standList?.links?.next;
      if (next) {
        ctx.patchState({
          loadStandListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.standService.getStandListLazy(next).subscribe({
          next: stands => ctx.dispatch(new GetStandListSuccess(stands, lazy)),
          error: error => ctx.dispatch(new GetStandListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadStandListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.standService.getStandList(filter).subscribe({
        next: stands => ctx.dispatch(new GetStandListSuccess(stands, lazy)),
        error: error => ctx.dispatch(new GetStandListError(error))
      });
    }
  }

  @Action(GetStandListSuccess)
  getStandListSuccess(ctx: StateContext<StandListStateModel>, { standList, lazy }: GetStandListSuccess): void {
    ctx.patchState({
      loadStandListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        standList: patch({
          data: append([...standList.data]),
          links: standList.links,
          meta: standList.meta
        })
      }));
    } else {
      ctx.patchState({
        standList
      });

    }
  }

  @Action(GetStandListError)
  getStandListError(ctx: StateContext<StandListStateModel>, { error }: GetStandListError): void {
    ctx.patchState({
      loadStandListStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(GetStandStatusList)
  getStandStatusList(ctx: StateContext<StandListStateModel>): void {
    this.standService.getStatusList().subscribe({
      next: standStatusList => ctx.dispatch(new GetStandStatusListSuccess(standStatusList)),
      error: error => ctx.dispatch(new GetStandStatusListError(error))
    });
  }

  @Action(GetStandStatusListSuccess)
  getStandStatusListSuccess(ctx: StateContext<StandListStateModel>, { standStatusList }: GetStandStatusListSuccess): void {
    ctx.patchState({
      standStatusList
    });
  }

  @Action(GetStandStatusListError)
  getStandStatusListError(ctx: StateContext<StandListStateModel>, { error }: GetStandStatusListError): void {
    ctx.patchState({
      standStatusList: []
    });
  }


  @Action(ClearScrollPositionStandList)
  clearScrollPositionStandList(ctx: StateContext<StandListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionStandList)
  updateScrollPosition(ctx: StateContext<StandListStateModel>, { position }: UpdateScrollPositionStandList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedStandId)
  setLastOpenedDocId(ctx: StateContext<StandListStateModel>, { standId }: SetLastOpenedStandId): void {
    ctx.patchState({ lastOpenedDocId: standId });
  }

  @Action(UpdatedStandByWS)
  updatedStandBuWS(ctx: StateContext<StandListStateModel>, { stand }: UpdatedStandByWS): void {
    ctx.setState(patch({
      standList: patch({
        data: updateItem(o => o?.id === stand.id, stand)
      })
    }));
  }

  @Action(CreatedStandByWS)
  createdStandByWS(ctx: StateContext<StandListStateModel>, { stand }: CreatedStandByWS): void {
    ctx.setState(patch({
      standList: patch({
        data: insertItem(stand, 0),
        meta: patch({
          totalItems: ctx.getState().standList?.meta?.totalItems + 1
        })
      })
    }));
  }


  @Action(StandsCountWS)
  ordersCountWs(ctx: StateContext<StandListStateModel>, { standsCount }: StandsCountWS): void {
    ctx.patchState({ standsCount });
  }

  @Action(AcceptedStandCountWS)
  acceptedStandCountWS(ctx: StateContext<StandListStateModel>, { standsCount }: AcceptedStandCountWS): void {
    ctx.setState(patch({
      standsCount: patch({
        acceptedCount: standsCount
      })
    }));
  }

  @Action(GetStandsCount)
  getOrdersCount(ctx: StateContext<StandListStateModel>): void {
    this.standService.getStandsCount().subscribe({
      next: standsCount => ctx.patchState({ standsCount }),
      error: err => {
        console.error('Error fetching orders count:', err);

      }
    });
  }

}


